module.exports = __webpack_public_path__ + "static/media/article.f3b11611.svg";